import { memberInfoMap } from '../constants/PortalMaps.js';
import lodash from 'lodash';

const assignValue = (input) => {
    if (typeof input === 'object') {
        if (input.locationType === 'session') {
            // Retrieve value from session storage
            if (input.key) {
                const temp = JSON.parse(sessionStorage.getItem(input.locationName));
                return lodash.get(temp, input.key);
            } else {
                return sessionStorage.getItem(input.locationName);
            }
        } else if (input.locationType === 'localStorage') {
            // Retrieve value from local storage
            if (input.key) {
                const temp = JSON.parse(localStorage.getItem(input.locationName));
                return lodash.get(temp, input.key);
            } else {
                return localStorage.getItem(input.locationName);
            }
        }
    } else {
        //Hardcoded value
        return input;
    }
};

const doMapping = () => {
    let request_obj = memberInfoMap[window.location.host];
    if (request_obj !== undefined) {
        Object.entries(request_obj).forEach(([key, value]) => {
            Object.entries(value).forEach(([key2, value2]) => {
                request_obj[key][key2] = assignValue(value2);
            });
        });
    } else {
        request_obj = {};
    }
    return request_obj;
};

export { doMapping };
